/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import React from "react";

import { Typography } from "@mui/material";

import { colors } from "@dotnet/telematics-design-system";

interface BubbleWithTextProps {
  title: string;
  subtitle: string;
  icon: React.JSX.Element;
  isMobile: boolean;
}

const BubbleWithText = ({
  title,
  subtitle,
  icon,
  isMobile
}: BubbleWithTextProps) => {
  const circleWidthHeight = isMobile ? "40px" : "58px";

  const iconSize = isMobile ? "20px" : "24px";

  return (
    <div
      css={css({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        span: {
          maxWidth: isMobile ? "80px" : "200px"
        }
      })}
    >
      <div
        css={css({
          display: "grid",
          placeItems: "center",
          width: circleWidthHeight,
          height: circleWidthHeight,
          border: `2px solid ${colors.blue700}`,
          color: colors.blue700,
          borderRadius: "50%",
          backgroundColor: colors.white,
          marginBottom: "8px",

          svg: {
            height: iconSize,
            width: iconSize
          }
        })}
      >
        {icon}
      </div>
      <div
        css={css({
          display: "flex",
          flexDirection: "column",
          minHeight: "64px"
        })}
      >
        <Typography
          variant="body2SemiBold"
          css={css(
            isMobile && {
              fontSize: "7px",
              lineHeight: "10px"
            }
          )}
        >
          {title}
        </Typography>
        <Typography
          variant="body3Regular"
          css={css(
            isMobile && {
              fontSize: "6px",
              lineHeight: "8px"
            }
          )}
        >
          {subtitle}
        </Typography>
      </div>
    </div>
  );
};

export default BubbleWithText;
